<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import chartResizeMixin from "./chartResizeMixin";


export default {
    name: "smallFldsRadarEchart",
    mixins: [chartResizeMixin],
    props: {
        id:{
            type: String,
            default:"small_flds_radar_echarts"
        },
        dataList:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        dataList(newValue,oldValue){
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            radarChart: null,
            chartList:[],
            chartOption:{
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    data: ['当前值', '常模'],
                    bottom: '-1%',
                    left: 'center'
                },
                aria:{
                    enabled:true,
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        {name:"TT教师讲话比率",max:1},
                        {name:"PT学生讲话比率",max:1},
                        {name:"SC沉默或非活跃比率",max:1},
                        {name:"TQR教师发问比率",max:1},
                        {name:"PIR学生自发发问比率",max:1},
                        {name:"CCR聚焦比率",max:1},
                        {name:"SSR师生话题交流稳定",max:1},
                        {name:"PSSR学生表达稳定",max:1},
                    ]
                },
                series: [
                    {
                        color: [
                            '#54b4dc',
                            '#f0a959',
                        ],
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        type: 'radar',
                        data: [
                            {
                                value: [0,0,0,0,0,0,0,0],
                                name: '当前值',
                                label: {
                                    show: true,
                                    fontSize: 13,
                                    color: '#54b4dc',
                                    formatter: function (params) {
                                        return params.value;
                                    }
                                }
                            },
                            {
                                value: [0.68,0.2,0.12,0.26,0.34,0.55,0.5,0.35],
                                name: '常模',
                                label: {
                                    show: true,
                                    fontSize: 12,
                                    color:"#f0a959",
                                    formatter: function (params) {
                                        return params.value;
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.chartList = this.dataList;
            if (!this.chartList||this.chartList.length===0){
                return;
            }
            this.chartOption.series[0].data[0].value = this.chartList;
            this.radarChart = echarts.init(document.getElementById(this.id));
            this.radarChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    > div {
        width: 100%;
        max-width: 400px;
        height: 400px;
        margin: auto;
    }
    div + div {
        margin-left: 10px;
    }
}
</style>